import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { NavItem } from "@/components/common/AppSidebar/types";
import { useAnalytics } from "@/lib";
import { canNavigateAway } from "@/lib/navigationGuard";

export const useNavItemClick = ({
  url,
  onClick,
  dataAttr,
  dataText,
}: Pick<NavItem, "url" | "onClick" | "dataAttr" | "dataText">) => {
  const router = useRouter();
  const { track } = useAnalytics();

  return useCallback(() => {
    if (dataAttr) {
      track(dataAttr, dataText ? { event_text: dataText } : undefined);
    }

    if (!url) {
      onClick?.();
      return;
    }

    const isExternalLink = url.startsWith("http");
    if (isExternalLink) {
      window.open(url, "_blank", "noopener");
      return;
    }

    const isAdminRoute = url.startsWith("/admin") || url.includes("/admin");
    if (isAdminRoute) {
      // A full page load, so the guarded router never sees it.
      if (!canNavigateAway(url)) return;
      window.location.href = url;
      return;
    }

    router.push(url);
    onClick?.();
  }, [router, url, onClick, dataAttr, dataText, track]);
};
